import { ContentWidthContainer } from "../components/ContentWidthContainer";
import { PageHeader } from "../components/PageHeader";
import { HeaderText, Information } from "../components/StaticPageComponents";

export const Blog: React.FC = () => (
  <>
    <PageHeader>Holiday Home Buying</PageHeader>
    <ContentWidthContainer>
      <HeaderText>1 – Location Location Location!</HeaderText>
      <Information>
        It’s important you pick the ideal area for your own needs. Somewhere that’s far enough away
        where you can switch off, relax and have new adventures. But not so far that the drive
        becomes a chore over the years. An area you probably already know but want get to visit more
        often. Most people chose an area that’s between an hour and a little over two hours drive
        from home.
      </Information>
      <HeaderText>2 – Research the parks</HeaderText>
      <Information>
        What’s your ideal park? Lively with lots of facilities, or small and quiet? Parks come in a
        shapes and sizes, so do your research and you will ensure you find the park that’s right for
        you. That’s where we come in! We can help introduce you to a range of parks in your chosen
        area, carefully selected as being amongst the best in the region.
      </Information>
      <HeaderText>3 – What type of holiday home should I buy?</HeaderText>
      <Information>
        There’s a huge choice available, with a wide range of prices. Many people choose a used
        holiday home initially, and if they like the ownership lifestyle then upgrade to a newer and
        larger model. Sizes vary from smaller traditional static caravans of around 300 square feet
        up to luxury lodges of over 800 square feet. All newer models are double glazed and
        centrally heated and come fully equipped with furniture and everything ready to enjoy! So
        even a budget model is a great way to experience the great holiday home lifestyle!
      </Information>
      <HeaderText>4 – How many bedrooms?</HeaderText>
      <Information>
        Most holiday home models have a choice of two or three bedrooms. But more isn’t necessarily
        best. Choose carefully, as with three bedrooms the compromise is that your bedrooms and
        living area will be slightly smaller, so two bedroom models feel more spacious. A third
        bedroom may sound great, but if its rarely used do you really need it? If you plan on
        letting a third bedroom generally is a good idea as it appeals to more people, and during
        the school holidays in particular will allow you to achieve higher tariff so a good tip to
        remember.
      </Information>
      <HeaderText>5 – What are the limits on using my holiday home?</HeaderText>
      <Information>
        Each park has its own season length that is determined by the planning consent, with most
        parks closing for a few weeks or so in the winter period, typically in January / February.
        During the open season you are usually free to use your holiday home as often as you want
        and for as long as you want. But the rules vary by park so its important that you find a
        park that suits your needs.
      </Information>
      <HeaderText>6 – Can I live permanently in a holiday home?</HeaderText>
      <Information>
        A holiday home cannot be used as your main residence, and the park will explain to you what
        that means in practice. Holiday parks are different to Park Homes on a fully residential
        site.
      </Information>
      <HeaderText>7 - Is Letting a good idea?</HeaderText>
      <Information>
        For many people letting their holiday home when they are not using it makes great sense and
        helps fund the holiday home ownership lifestyle. Most parks allow letting and can help
        manage the letting process for you. Some parks don’t allow letting and are exclusive for
        holiday home owners, so it’s important you find a park which matches your needs. It’s good
        to also think ahead and have options for the future should your needs change.
      </Information>
      <HeaderText>8 - How long will I be able to own it on site?</HeaderText>
      <Information>
        When you buy, you will enter into a pitch licence agreement which is your contract with the
        park that sets out all your rights and the detail you need to know. The terms are approved
        by industry Trade Associations to ensure you have high levels of consumer protection. The
        contract will set out the length of time a holiday home can remain on site, which varies by
        park and the remaining licence period is based on when your chosen holiday home was
        constructed. Most parks offer a longer licence period for lodges, as they are manufactured
        to very specification and designed to last many decades.
      </Information>
      <HeaderText>9 - Your annual running costs</HeaderText>
      <Information>
        Running costs vary by park, so it’s good to ensure you work out what is affordable for you.
        Generally, parks with more facilities are more expensive, and there are regional trends. You
        will also need to factor it your utility costs etc. Most people find that their electricity
        costs are lower than expected as owners benefit from the bulk buying of the park. The park
        will explain the likely costs to you and remember that letting can offer the chance of
        covering most of your costs, and depending on the number of weeks let and demand you could
        even make a surplus.
      </Information>
      <HeaderText>10 - Arrange your visit</HeaderText>
      <Information>
        The only way to find out if a park is right for you is to see it at first hand, by arranging
        a visit. You will have a guided tour of the park and all the facilities. On your visit you
        will be able to view the latest range of holiday homes and ask questions so that you fully
        understand what is involved. Once you register with Breakfree Holiday Homes, we will put you
        in touch with the major park operators in your chosen area. We do recommend that you do book
        an appointment before you visit as parks can be very busy at times and by booking in
        advanced a member of the team will have scheduled time to devote to showing you around and
        explaining things. You might also want to also book a Breakfree holiday at your preferred
        park so you can take your time to enjoy the park fully over a few days.
      </Information>
    </ContentWidthContainer>
  </>
);
